import customEvent from '../src/custom-event';

export default customEvent();
